import React from 'react';
import './index.scss';
import AsyncSection from '../../../../../../../../Components/AsyncSection';
import SVGIcons from '../../../../../../../../Components/SVGIcons';
import { SUMMARY_CARDS, SUMMARY_NOTE } from './constants';
import { getScaleConfig } from '../../../../utils/scaleConfig';

// Mirrors the real card's frame (border/shadow/radius/blob) so the loading
// state reads as "these 4 cards are filling in", not a generic placeholder.
const SummaryCardsSkeleton = () => (
  <div className="summary-cards">
    <div className="summary-cards__grid">
      {SUMMARY_CARDS({}).map((card) => (
        <div key={card.key} className="summary-card summary-card--skeleton">
          <span className="summary-card__blob" />
          <span className="summary-card__icon skeleton-block" />
          <span className="skeleton-block skeleton-block--label" />
          <span className="skeleton-block skeleton-block--value" />
          <span className="skeleton-block skeleton-block--description" />
        </div>
      ))}
    </div>
  </div>
);

const SummaryCards = (props) => {
  let apiData = props.fetchBenchmarkKpiTilesApi.data ? props.fetchBenchmarkKpiTilesApi.data : {}
  return (
    <AsyncSection api={props.fetchBenchmarkKpiTilesApi} skeleton={<SummaryCardsSkeleton />}>
      <div className="summary-cards">
        <div className="summary-cards__grid">
          {SUMMARY_CARDS(apiData, getScaleConfig(props.scaleType)).map((card) => (
            <div
              key={card.key}
              className={`summary-card summary-card--${card.theme}`}
            >
              <span className="summary-card__blob" />
              <span className="summary-card__icon">
                <SVGIcons type={card.icon} />
              </span>
              <p className="summary-card__label">{card.label}</p>
              <p className="summary-card__value">{card.value}</p>
              <p className="summary-card__description">{card.description}</p>
            </div>
          ))}
        </div>
        <p className="summary-cards__note">{SUMMARY_NOTE(apiData)}</p>
      </div>
    </AsyncSection>
  );
};

export default SummaryCards;
